"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactTableDraggableRow = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_table_1 = require("@tanstack/react-table");
var classnames_1 = __importDefault(require("classnames"));
var react_dnd_1 = require("react-dnd");
var icons_1 = require("../../../icons");
var ReactTableDraggableRow = function (_a) {
    var row = _a.row, onDragRow = _a.onDragRow, disabled = _a.disabled;
    var _b = (0, react_dnd_1.useDrop)({
        accept: 'row',
        drop: function (draggedRow) { return onDragRow(draggedRow.index, row.index); },
    }), dropRef = _b[1];
    var _c = (0, react_dnd_1.useDrag)({
        collect: function (monitor) { return ({
            isDragging: monitor.isDragging(),
        }); },
        item: row,
        type: 'row',
    }), isDragging = _c[0].isDragging, dragRef = _c[1], previewRef = _c[2];
    return ((0, jsx_runtime_1.jsx)("tr", __assign({ ref: previewRef, style: { opacity: isDragging ? 0.5 : 1 } }, { children: row.getVisibleCells().map(function (cell, i) {
            return i === 0 ? ((0, jsx_runtime_1.jsx)("td", __assign({ ref: dropRef }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "position-relative" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "position-absolute start-50 translate-middle-x", style: { top: '-2px' } }, { children: (0, jsx_runtime_1.jsx)("button", __assign({ ref: dragRef, className: (0, classnames_1.default)('bg-transparent border-0 text-default', disabled && 'pe-none opacity-20') }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ "aria-hidden": "true" }, { children: (0, jsx_runtime_1.jsx)(icons_1.DragHandleBars24, {}) })) })) })) })) }), cell.id)) : ((0, jsx_runtime_1.jsx)("td", { children: (0, react_table_1.flexRender)(cell.column.columnDef.cell, cell.getContext()) }, cell.id));
        }) })));
};
exports.ReactTableDraggableRow = ReactTableDraggableRow;
